import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBenefit, ElBenefitContent, ElColumn, elGapBenefit, elBgWhite } from "./benefit.css";
import { Container } from "../../layout";
import { ElHeadLine } from "../head-title";

interface IBenefitProps extends HTMLAttributes<HTMLElement> {}

export const Benefit: FC<IBenefitProps> = ({ children, ...props }) => {
  return (
    <ElBenefit {...props}>
      <Container className={elGapBenefit}>
        <ElBenefitContent>
          <ElHeadLine style={{ maxWidth: "300px", "--hashTag": `"#EXPLORE PROGRAM"` }}>Apa yang Akan Kamu Dapatkan?</ElHeadLine>
        </ElBenefitContent>
        <ElBenefitContent>
          <ElColumn className={elBgWhite}>
            <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/programs/01.png' alt="" />
            <h3>
              <span>Mentoring Bersama High Level Industri</span>
            </h3>
            <p>
              Dapat bimbingan personal dari pemimpin dan ahli industri. Mereka akan berbagi strategi rahasia dan pengalaman berharga untuk membawa startup-mu ke level berikutnya. Ini kesempatan emasmu
              untuk belajar dari yang terbaik!
            </p>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/programs/02.png' alt="" />
            <h3>
              <span>Pilot Project Secara Langsung</span>
            </h3>
            <p>
              Kami tidak hanya memberi teori. Kami akan mendampingi kamu secara langsung dalam mewujudkan dan menguji ide-idemu jadi proyek percontohan yang nyata. Pastikan solusimu siap diluncurkan
              ke pasar.
            </p>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <img src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/programs/03.png' alt="" />
            <h3>
              <span>Networking</span>
            </h3>
            <p>
              Dapatkan koneksi langsung ke program dan inisiatif pemerintah yang relevan. Ini membuka pintu bagi dukungan, kemitraan strategis, bahkan potensi pendanaan yang bisa mempercepat
              pertumbuhan startup-mu.
            </p>
          </ElColumn>
        </ElBenefitContent>
      </Container>
    </ElBenefit>
  );
};
